export enum MapTypes {
  APPLICATION_MODULES = 'application-modules',
  APPLICATION_OBJECTS = 'application-objects',
  APPLICATION_INTENTS = 'application-intents',
  APPLICATION_VARIABLES = 'application-variables',
  MODULES = 'modules',
  APP_PROPERTIES = 'appProperties',
  BRANCHING = 'branching',
  BRANCHING_MAP = 'branchingMap',
  CCXML = 'ccxml',
  COMPOUND_INTENTS = 'compoundIntents',
  CSV_DATA = 'csvData',
  DESCRIPTION = 'description',
  DIALOGS = 'dialogs',
  FILLER_PROMPTS = 'fillerPrompts',
  FUNCTIONS = 'functions',
  GLOBAL_INTENTS = 'globalIntents',
  GRAPHQL_SCHEMAS = 'graphQLSchemas',
  LANGUAGES = 'languages',
  OMNICHANNEL = 'omniChannel',
  UNIT_TESTS = 'unitTests',
  SETTINGS = 'settings',
  GLOBAL_ERROR_HANDLING = 'globalErrorHandling',
  GLOBAL_EXCEPTION_HANDLING = 'globalExceptionHandling',
  GLOBAL_LOOP_HANDLING = 'globalLoopHandling', //inARow, xAndOut
  INTENT_HANDLING = 'intentHandling', // string: inARowLimit, xAndOutLimit // number: inARowLimitLastLocalChange, xAndOutLimitLastLocalChange
  FOLDERS = 'folders',
  NO_INPUT_TIMEOUT = 'noInputTimeout',
  DTMF_LIVE_AGENT_OVERRIDE_PATTERN = 'dtmf_live_agent_override_pattern',
  APPLICATION_VERSION = 'applicationVersion'
}
